// extracted by mini-css-extract-plugin
export default {"PasteButton":"pastebutton_PasteButton__O5JYq"};